module.exports = __webpack_public_path__ + "static/media/24-ViimenTV.6e674eff.png";